import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sm/wds-react';
import { IconChevronDown, IconChevronUp } from '@sm/wds-icons';
import classNames from 'classnames';
import { NavBarAnonContext } from '../NavBarAnonContext.js';

export const Menu = ({ path, title, menuKey, children }) => {
  const { color, submenuOpened, toggleSubmenu } = useContext(NavBarAnonContext);

  const linksClassname = classNames(
    `sm-header__nav-cta--${color}`,
    'sm-header__text',
    { 'sm-header--open': submenuOpened === menuKey }
  );

  return (
    <Choose>
      <When condition={path === ''}>
        <div className="wds-display--inline-block" key={menuKey}>
          <Button
            variant="text"
            className={linksClassname}
            color={color}
            onClick={() => toggleSubmenu(menuKey)}
          >
            {title}
            <Choose>
              <When condition={submenuOpened === menuKey}>
                <IconChevronUp size="xs" />
              </When>
              <Otherwise>
                <IconChevronDown size="xs" />
              </Otherwise>
            </Choose>
          </Button>
          {children}
        </div>
      </When>

      <Otherwise>
        <Button
          key={menuKey}
          variant="text"
          color={color}
          href={path}
          className={`sm-header__nav-cta--${color} sm-header__text`}
        >
          {title}
        </Button>
      </Otherwise>
    </Choose>
  );
};

Menu.propTypes = {
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
  menuKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
Menu.defaultProps = {
  path: '',
};

export default Menu;
